import angular from 'angular'
import './communities.service'
import './post_hidden/post_hidden.controller'
import './post_hidden/post_hidden.service'
import './posts/posts.controller'
import './posts/posts.service'

angular
  .module('admin.communities', [
    'admin.communities.service',
    'admin.communities.posts',
    'admin.communities.post_hidden',
  ])
  .controller('CommunitiesCtrl', CommunitiesCtrl)

/** @ngInject */
function CommunitiesCtrl($timeout, CommunitiesService) {
  var vm = this
  vm.items = []

  function reloadPagination() {
    vm.totalUsers = 0
    vm.oldPage = 0
    vm.usersPerPage = 25
    vm.currentPage = 25
    vm.first = true
    vm.totalItems = 0
    vm.pagination = {
      current: 1,
    }
  }

  reloadPagination()

  vm.roles = [
    {
      id: 'all',
      name: 'All',
    },
    {
      id: 'employee',
      name: 'Employee',
    },
    {
      id: 'producer',
      name: 'Producer',
    },
  ]

  vm.role = vm.roles[0].id
  load(1)

  function load(pageNumber) {
    if (pageNumber === 1) {
      vm.pagination.current = 1
    }
    if (!vm.first) {
      vm.currentPage = pageNumber * 25
      vm.oldPage = vm.currentPage - 25
    } else {
      vm.first = false
    }
    vm.items = []
    CommunitiesService.search(vm.role, vm.oldPage, 25).then(function(result) {
      if (vm.totalItems === 0) {
        vm.totalItems = result.ct
      }

      vm.items = result.results
    })
  }

  vm.filter = function() {
    reloadPagination()
    load(1)
  }

  vm.pageChanged = function(newPage) {
    load(newPage)
  }

  vm.sort = function(type) {
    vm.sortReverse = !vm.sortReverse
    if (vm.sortReverse) {
      vm.sortType = type + '-asc'
    } else {
      vm.sortType = type + '-desc'
    }

    load(vm.pagination.current)
  }

  vm.add = function() {
    $('#callModal').click()
    $timeout(function() {
      $('#username').focus()
    }, 500)
  }
}
